import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LangContext } from '../../context/LangContext';

import SelectLang from '../../components/SelectLang';

import "./style.css"
import Paging from '../../components/Paging';

function Illustrations() {
    const { translations } = useContext(LangContext);
    const headerWidth = useSelector(state => state.options.headerWidth);

    const [paging, setPaging] = useState(0);
    const [imgSize, setImgSize] = useState(null);
    const [illustration, setIllustration] = useState(null);
    const [illustrationsData, setIllustrationsData] = useState(null);

    useEffect(() => {
        const fetchIllustrationsData = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/illustrations/get`);
            const res = await req.json();

            if (req.status !== 200) {
                alert(res.message);
                return
            };

            const chunkSize = headerWidth < 700 ? 10 : 15;
            const chunkedData = [];

            for (let i = 0; i < res.length; i += chunkSize) {
                const chunk = res.slice(i, i + chunkSize);
                chunkedData.push(chunk);
            }

            setIllustrationsData(chunkedData);
            setPaging(0);
        }
        fetchIllustrationsData();
    }, [headerWidth]);

    useEffect(() => {
        if (!illustration?.image?.url) {
            setImgSize(null)
            return;
        }

        const img = new Image();
        img.src = illustration.image.url;

        img.onload = () => {
            setImgSize({ width: img.naturalWidth, height: img.naturalHeight });
        };
    }, [illustration]);

    return (
        <div className='page page_illustrations'>
            <p className="title_page">
                - <span>Illustrations</span> -
            </p>

            <SelectLang />

            {illustrationsData &&
                <section className="sect_illustrations">
                    <ul className="illustrations_list">
                        {illustrationsData[paging].map((illust, idx) => (
                            <li key={idx}>
                                <button onClick={() => setIllustration(illust)}>
                                    <div className="preview">
                                        <i style={{ backgroundImage: `url(${illust.image._url})` }}></i>
                                    </div>

                                    <h2>- {illust.title} -</h2>
                                </button>
                            </li>
                        ))}
                    </ul>

                    {illustrationsData.length > 1 && <Paging data={illustrationsData} paging={paging} setPaging={setPaging} />}
                </section>
            }


            {illustration && imgSize &&
                <div className="mdl_show_illustration">
                    <div className="content">
                        <div className="illustration">
                            <i style={{
                                backgroundImage: `url(${illustration.image.url})`,
                                aspectRatio: `${imgSize.width} / ${imgSize.height}`
                            }}></i>
                        </div>

                        <ul className="descrip_list">
                            <li>
                                <span>{translations.title} :</span>
                                {illustration.title}
                            </li>
                            <li>
                                <span>{translations.serie} :</span>
                                {illustration.serie}
                            </li>
                            <li>
                                <span>Personnage :</span>
                                {illustration.perso}
                            </li>
                            <li>
                                <span>{translations.date_of_creation} :</span>
                                {illustration.created}
                            </li>
                        </ul>
                    </div>

                    <button onClick={() => setIllustration(null)}>
                        <i className='fas fa-xmark'></i>
                    </button>
                </div>
            }
        </div>
    )
}

export default Illustrations;